import { Component, OnInit } from '@angular/core';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { UserService } from '../users/user.service';
import { User } from '../users/user.model';
import { TeamService } from '../teams/team.service';
import { Team } from '../teams/team.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    public hasTeam = false;
    public currentUserSubscription: any;
    public name: string;
    public currentUser: User;
    public showAllTeams: boolean;
    public showPersonalTeams: boolean;
    public personalTeams: Team[] = [];

    constructor(private adalService: AdalService,
        private userService: UserService,
        private teamService: TeamService) { }

    ngOnInit() {
        this.name = this.adalService.userInfo.profile.name;

        if (this.userService.currentUser)
        {
            this.currentUser = this.userService.currentUser;
            this.processCurrentUser();
        }

        this.currentUserSubscription =
            this.userService.currentUserAuthenticated.subscribe((currentUser: User) => {
                this.currentUser = this.userService.currentUser;
                this.processCurrentUser();
            });
    }

    ngOnDestroy() {
        if (this.currentUserSubscription)
            this.currentUserSubscription.unsubscribe()
    }

    processCurrentUser()
    {
        if (this.currentUser.id) {
            this.teamService.getTeamsByUserId(this.currentUser.id)
                .then(result => {
                    this.personalTeams = result;
                    if (this.personalTeams.length > 0) {
                        this.showPersonalTeams = true;
                    }
                    else {
                        this.showAllTeams = true;
                    }
                })
                .catch(error => console.log(error));
        }
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/home/home.component.ts